import React from "react";
import PropTypes from "prop-types";

import SVG from "components/base/SVG";

import css from "./style.scss";

function SearchIcon({ searching, handleSearchClick }) {
  return (
    <button onClick={() => handleSearchClick()} className={css.transparentButton}>
      <div className={css.actionIcon}>
        <SVG
          icon={searching ? "search-active" : "search-inactive"}
          title="search"
          height={16}
          width={16}
        />
      </div>
    </button>
  );
}

SearchIcon.propTypes = {
  searching: PropTypes.bool.isRequired,
  handleSearchClick: PropTypes.func.isRequired,
};

export default SearchIcon;

